import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
// import ContentAssetSwitcher from "@components/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {data: AdvancedSideAssetModuleType}

const InBriefSection = (props: Props) => {
	return (
		<section>
			<Separator size={128} />
			<ContainerWrapper>
				<Typography
					content={props.data?.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				<ContentAssetSwitcher
					contentAssetProps={{
						withAspectRation: true,
					}}
					data={props.data}
				/>
			</ContainerWrapper>
			<Separator />
		</section>
	)
}

export default InBriefSection
